import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AdminStore } from '../stores/admin.store';

/**
 * 관리자 인증 상태를 체크하여 비인증 사용자를 로그인 페이지로 리다이렉트하는 가드입니다.
 */
export const authGuard: CanActivateChildFn = async (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const adminStore = inject(AdminStore);
  const router = inject(Router);
  const admin = adminStore.admin();

  // Auth Guard
  if (!admin) {
    try {
      await adminStore.fetch();
      router.navigate([state.url]);
      return true;
    } catch (error) {
      router.navigate(['/sign-in']);
      return false;
    }
  }

  return true;
};
